document.addEventListener("DOMContentLoaded", () => {

    // get all tab blocks
    const filterTabs = document.querySelectorAll(".filter-tabs-js");

    // stop here if non exist
    if (!filterTabs) return;

    // loop through each tab block
    filterTabs.forEach((tab, index)=>{

        const tabIndex = index;

        tab.setAttribute("id", "filter-tabs-"+tabIndex);

        // get all tab navigation items for loop
        var tabNavigationItems = tab.querySelectorAll('.toggle-btn');

        // stop here if non exist
        if (!tabNavigationItems) return;

        // loop through each tab navigation item
        tabNavigationItems.forEach((tabNavItem, index)=>{

            // update tab navigation item elements as needed
            if (index == 0) {
                tabNavItem.classList.add('is-active');
                tabNavItem.setAttribute("aria-expanded", "true");
            }

            tabNavItem.setAttribute("data-toggle-target", "#filter-tabs-"+tabIndex+"-panel-"+index);
            tabNavItem.setAttribute("aria-controls", "filter-tabs-"+tabIndex+"-panel-"+index);
            tabNavItem.setAttribute("data-toggle-group", ".filter-tabs-"+tabIndex);
        });

        // get all tab content items for loop
        var tabContentItems = tab.querySelectorAll('.toggle-panel');

        // stop here if non exist
        if (!tabContentItems) return;

        // loop through each tab content item
        tabContentItems.forEach((tabContentItem, index)=>{

            // update tab content item elements as needed
            if (index == 0) {
                tabContentItem.classList.add('is-active');
                tabContentItem.setAttribute("aria-hidden", "false");
            }

            tabContentItem.setAttribute("id", "filter-tabs-"+tabIndex+"-panel-"+index);
            tabContentItem.setAttribute("aria-labelledby", "filter-tabs-"+tabIndex+"-panel-"+index);
            tabContentItem.classList.add('filter-tabs-'+tabIndex);
        });
    });
});
